import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoAddressBloc from "../../blocs/retirement/info-perso/REInfoAddressBloc";

export default function REInfoAddressPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Complétez votre adresse</h1>
       
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
           <REInfoAddressBloc />
        </div>
      </div>
   
    )

}